// Status: 'available' | 'launch' | 'sold'
// vaastu: true for East-facing + NE corner plots (auto-assigned)
const plotData = [
  { id: 2, area: 1195, facing: 'EAST', status: 'launch', vaastu: true },
  { id: 3, area: 1195, facing: 'EAST', status: 'launch', vaastu: true },
  { id: 4, area: 1195, facing: 'EAST', status: 'sold', vaastu: true },
  { id: 5, area: 1195, facing: 'EAST', status: 'launch', vaastu: true },
  { id: 6, area: 1195, facing: 'EAST', status: 'launch', vaastu: true },
  { id: 7, area: 1195, facing: 'EAST', status: 'available', vaastu: true },
  { id: 8, area: 1195, facing: 'EAST', status: 'available', vaastu: true },
  { id: 9, area: 1195, facing: 'EAST', status: 'available', vaastu: true },
  { id: 10, area: 1195, facing: 'EAST', status: 'launch', vaastu: true },
  { id: 11, area: 1423, facing: 'NORTH & EAST', status: 'available', vaastu: true },
  { id: 12, area: 1436, facing: 'NORTH & WEST', status: 'available' },
  { id: 13, area: 1195, facing: 'WEST', status: 'available' },
  { id: 14, area: 1195, facing: 'WEST', status: 'available' },
  { id: 15, area: 1195, facing: 'WEST', status: 'sold' },
  { id: 16, area: 1195, facing: 'WEST', status: 'available' },
  { id: 17, area: 1195, facing: 'WEST', status: 'available' },
  { id: 18, area: 1195, facing: 'WEST', status: 'available' },
  { id: 19, area: 1195, facing: 'WEST', status: 'available' },
  { id: 20, area: 1195, facing: 'WEST', status: 'available' },
  { id: 21, area: 1142, facing: 'WEST', status: 'available' },
  { id: 24, area: 1003, facing: 'EAST', status: 'available', vaastu: true },
  { id: 25, area: 1195, facing: 'EAST', status: 'sold', vaastu: true },
  { id: 26, area: 1195, facing: 'EAST', status: 'available', vaastu: true },
  { id: 27, area: 1195, facing: 'EAST', status: 'available', vaastu: true },
  { id: 28, area: 1195, facing: 'EAST', status: 'available', vaastu: true },
  { id: 29, area: 1195, facing: 'EAST', status: 'available', vaastu: true },
  { id: 30, area: 1195, facing: 'EAST', status: 'available', vaastu: true },
  { id: 31, area: 1195, facing: 'EAST', status: 'available', vaastu: true },
  { id: 32, area: 1195, facing: 'EAST', status: 'available', vaastu: true },
  { id: 33, area: 1433, facing: 'NORTH & EAST', status: 'available', vaastu: true },
  { id: 34, area: 971, facing: 'NORTH & WEST', status: 'available', vaastu: true },
  { id: 35, area: 794, facing: 'NORTH', status: 'launch', vaastu: true },
  { id: 36, area: 1124, facing: 'SOUTH & EAST', status: 'available' },
  { id: 37, area: 1122, facing: 'EAST', status: 'available', vaastu: true },
  { id: 38, area: 1680, facing: 'SOUTH', status: 'sold' },
  { id: 39, area: 1690, facing: 'SOUTH', status: 'available' },
  { id: 40, area: 1693, facing: 'SOUTH', status: 'available' },
  { id: 41, area: 1688, facing: 'SOUTH', status: 'available' },
  { id: 42, area: 1694, facing: 'SOUTH', status: 'sold' },
  { id: 43, area: 1694, facing: 'SOUTH', status: 'available' },
  { id: 44, area: 1688, facing: 'SOUTH', status: 'available' },
  { id: 45, area: 2193, facing: 'SOUTH', status: 'available' },
  { id: 46, area: 2972, facing: 'NORTH', status: 'available' },
  { id: 47, area: 1477, facing: 'NORTH', status: 'available' },
  { id: 48, area: 1397, facing: 'NORTH', status: 'available' },
  { id: 49, area: 1321, facing: 'NORTH', status: 'available' },
  { id: 50, area: 1238, facing: 'NORTH', status: 'available' },
  { id: 51, area: 716, facing: 'NORTH', status: 'launch' },
  { id: 52, area: 684, facing: 'NORTH', status: 'launch' },
  { id: 53, area: 657, facing: 'NORTH', status: 'launch' },
  { id: 54, area: 1136, facing: 'SOUTH & EAST', status: 'available' },
  { id: 55, area: 1142, facing: 'SOUTH', status: 'available' },
  { id: 56, area: 1141, facing: 'SOUTH', status: 'available' },
  { id: 57, area: 1132, facing: 'SOUTH', status: 'available' },
  { id: 58, area: 1394, facing: 'SOUTH', status: 'available' },
  { id: 59, area: 765, facing: 'WEST', status: 'sold', vaastu: true },
  { id: 60, area: 743, facing: 'WEST', status: 'available' },
];

export default plotData;

export const MEDIA = {
  heroWide: 'https://customer-assets-agu9un31.emergentagent.net/job_redhills-villas/artifacts/z662uoxg_WhatsApp%20Image%202026-07-16%20at%2015.34.42%20%282%29.jpeg',
  droneAerial: 'https://customer-assets-agu9un31.emergentagent.net/job_redhills-villas/artifacts/qkbi95ww_WhatsApp%20Image%202026-07-16%20at%2015.34.28.jpeg',
  droneOblique: 'https://customer-assets-agu9un31.emergentagent.net/job_redhills-villas/artifacts/grtqms8n_WhatsApp%20Image%202026-07-16%20at%2015.34.29%20%281%29.jpeg',
  layoutMap: 'https://customer-assets-agu9un31.emergentagent.net/job_redhills-villas/artifacts/jp5a8k9a_WhatsApp%20Image%202026-07-16%20at%2018.39.52%20%281%29.jpeg',
  areaStatement: 'https://customer-assets-agu9un31.emergentagent.net/job_redhills-villas/artifacts/u7e6z3vx_WhatsApp%20Image%202026-07-16%20at%2018.39.52.jpeg',
  gateAccess: 'https://customer-assets-agu9un31.emergentagent.net/job_redhills-villas/artifacts/2nb7pimr_image.png',
  signage: 'https://customer-assets-agu9un31.emergentagent.net/job_redhills-villas/artifacts/sqs7evbc_image.png',
  reraQR: 'https://customer-assets-agu9un31.emergentagent.net/job_redhills-villas/artifacts/1eam3n66_image.png',
  renderFront: 'https://customer-assets-agu9un31.emergentagent.net/job_redhills-villas/artifacts/6m7i1tt1_Layout%20with%20Villas%20options-02.jpg',
  renderOblique: 'https://customer-assets-agu9un31.emergentagent.net/job_redhills-villas/artifacts/rjusanpt_Layout%20with%20Villas%20options-01.jpg',
  siteVisitRender: 'https://customer-assets-agu9un31.emergentagent.net/job_redhills-villas/artifacts/aituikdn_image.png',
  happyFamily: 'https://images.unsplash.com/photo-1730130596425-197566414dc4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBmYW1pbHklMjBoYXBweSUyMG5ldyUyMGhvbWV8ZW58MHx8fHwxNzg0MjA4MDc0fDA&ixlib=rb-4.1.0&q=85',
  greenPark: 'https://images.unsplash.com/photo-1626456877396-5af019036c63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxncmVlbiUyMHBhcmslMjB0cmVlcyUyMHN1bmxpZ2h0fGVufDB8fHx8MTc4NDIwODA3M3ww&ixlib=rb-4.1.0&q=85',
};
